import React, { FC } from 'react';
import { styled } from '@mui/material';
import { Grid } from '@mui/system';
import { Header, SIDEBAR_DESKTOP } from 'dashboard409a/components';
import { useAttioValuationContext } from 'dashboard409a/context/AttioValuationContext';
import { ITheme } from 'theme/types';
import { IMainContainer } from './types';

const RootGrid = styled(Grid)(({ theme }) => ({
  width: '100%',
  minHeight: '100vh',
  zIndex: 100,
  backgroundColor: (theme as unknown as ITheme).palette.white,

  [theme.breakpoints.up('md')]: {
    paddingLeft: SIDEBAR_DESKTOP.width,
  },
}));

const MainGrid = styled(Grid)(({ theme }) => ({
  padding: `0 ${theme.spacing(1)}`,
  flex: 1,
  minHeight: 0,
  alignSelf: 'stretch',
}));

const MainContainer: FC<IMainContainer> = props => {
  const { children, currentCompany, isLoading, navigationItems } = props;
  const { currentAttioCompanyName } = useAttioValuationContext();

  const pageTitle = currentAttioCompanyName || currentCompany?.name || '';

  return (
    <RootGrid direction="column" wrap="nowrap">
      <Header isLoading={isLoading} navigationItems={navigationItems} pageTitle={pageTitle} />

      <MainGrid container direction="row" justifyContent="space-between" alignItems="stretch">
        {children}
      </MainGrid>
    </RootGrid>
  );
};

export default MainContainer;
